module.exports = __webpack_public_path__ + "img/4_144.04125d49.png";